import {RemoteGetAccessManagementPermissions} from 'data/usecases';
import {GetAccessManagementPermissions} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AccessManagementEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetAccessManagementPermissions = (): GetAccessManagementPermissions =>
	new RemoteGetAccessManagementPermissions(
		makeBFFApiUrl(AccessManagementEndpoints.permissions),
		makeAuthorizeHttpClientDecorator(),
	);
